import { CircularProgress, Typography } from '@material-ui/core';
import type { CockpitTimelineState } from '../controller/cockpitControllerTypes';
import { useCockpitStyles } from './cockpitStyles';

export const TimelineLoadState = ({
  timeline,
  loadingMore,
}: {
  timeline: CockpitTimelineState;
  loadingMore: boolean;
}) => {
  const classes = useCockpitStyles();
  if (timeline.status === 'loading') {
    return (
      <div className={classes.timelineState} role="status">
        <CircularProgress size={20} /> {loadingLabel(timeline, loadingMore)}
      </div>
    );
  }
  if (timeline.status === 'error') {
    return (
      <Typography className={classes.timelineState} role="alert">
        {timeline.page
          ? 'Não foi possível atualizar a timeline. O último resultado válido permanece visível.'
          : 'Não foi possível carregar a timeline.'}
      </Typography>
    );
  }
  return null;
};

export function isTimelineLoadingMore(timeline: CockpitTimelineState): boolean {
  return Boolean(
    timeline.status === 'loading' &&
      timeline.page &&
      (timeline.query.page ?? 1) > timeline.page.page,
  );
}

function loadingLabel(
  timeline: CockpitTimelineState,
  loadingMore: boolean,
): string {
  if (!timeline.page) return 'Carregando timeline.';
  if (loadingMore) return 'Carregando mais registros.';
  return 'Atualizando filtros; o último resultado permanece visível.';
}
